<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      @if (isEditMode()) {
        <img src="/public/svgs/edit-dark.svg" alt="" width="18" height="18" />
      } @else {
        <img src="/public/svgs/flag.svg" alt="" width="18" height="18" />
      }
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        @if (isEditMode()) {
          {{ 'app.components.addDutyDialog.editTitle' | translate }}
        } @else {
          {{ 'app.components.addDutyDialog.title' | translate }}
        }
      </h2>
      <p class="parent-dialog__subtitle">
        @if (isEditMode()) {
          {{ 'app.components.addDutyDialog.editSubtitle' | translate }}
        } @else {
          {{ 'app.components.addDutyDialog.subtitle' | translate }}
        }
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.addDutyDialog.close' | translate"
    (click)="onDiscard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (isEditMode() && assignedKid(); as kid) {
    <section class="parent-dialog__section add-duty__assigned-section">
      <span class="parent-dialog__section-label">{{ 'app.components.addDutyDialog.assignedKidLabel' | translate }}</span>
      <div class="parent-dialog__kid-card" aria-readonly="true">
        <span class="parent-dialog__kid-card-avatar">
          @if (kid.avatar) {
            <img [src]="kid.avatar" [alt]="kid.firstName" />
          } @else {
            <span>{{ { firstName: kid.firstName, lastName: kid.lastName } | initials }}</span>
          }
        </span>
        <span class="parent-dialog__kid-card-copy">
          <span class="parent-dialog__kid-card-name">{{ kid.firstName }}</span>
          <span class="parent-dialog__kid-card-meta">{{ 'app.components.addDutyDialog.assignedKidHint' | translate }}</span>
        </span>
      </div>
    </section>
  } @else if (kids().length > 0) {
    <section class="parent-dialog__section parent-dialog__section--kids">
      <div class="parent-dialog__section-head">
        <span class="parent-dialog__section-label">{{ 'app.components.addDutyDialog.kidsLabel' | translate }}</span>
        <div class="parent-dialog__section-actions">
          @if (selectedKidsCount() > 0) {
            <span class="parent-dialog__section-hint">
              {{ 'app.components.addDutyDialog.kidsSelected' | translate: { count: selectedKidsCount() } }}
            </span>
          }
          @if (showKidBulkActions()) {
            <button
              type="button"
              class="parent-dialog__section-action"
              (click)="toggleAllKids()"
            >
              @if (allKidsSelected()) {
                {{ 'app.components.addDutyDialog.clearKids' | translate }}
              } @else {
                {{ 'app.components.addDutyDialog.selectAllKids' | translate }}
              }
            </button>
          }
        </div>
      </div>
      <div
        class="parent-dialog__kids-scroll"
        tabindex="0"
        role="group"
        [attr.aria-label]="'app.components.addDutyDialog.kidsScrollAria' | translate"
      >
        <div class="parent-dialog__kids parent-dialog__kids--strip">
          @for (kid of kids(); track kid.id) {
            <button
              type="button"
              class="parent-dialog__kid"
              [class.parent-dialog__kid--selected]="isKidSelected(kid.id)"
              [attr.aria-pressed]="isKidSelected(kid.id)"
              (click)="toggleKidSelection(kid.id)"
            >
              <span class="parent-dialog__kid-avatar">
                @if (kid.avatar) {
                  <img [src]="kid.avatar" [alt]="kid.firstName" />
                } @else {
                  <span>{{ { firstName: kid.firstName, lastName: kid.lastName } | initials }}</span>
                }
              </span>
              <span class="parent-dialog__kid-name">{{ kid.firstName }}</span>
            </button>
          }
        </div>
      </div>
    </section>
  }

  <form class="parent-dialog__form" [formGroup]="dutyForm">
    <app-input-field
      formControlName="title"
      [label]="'app.components.addDutyDialog.taskName' | translate"
      [placeholder]="'app.components.addDutyDialog.taskNamePlaceholder' | translate"
      [validationErrors]="nameValidation()"
    />

    <app-input-field
      formControlName="content"
      [inputType]="'textarea'"
      [label]="'app.components.addDutyDialog.message' | translate"
      [placeholder]="'app.components.addDutyDialog.messagePlaceholder' | translate"
      [validationErrors]="messageValidation()"
    />

    <div class="add-duty__parent-note">
      <app-input-field
        formControlName="parentNote"
        [inputType]="'textarea'"
        [label]="'app.components.addDutyDialog.parentNote.label' | translate"
        [placeholder]="'app.components.addDutyDialog.parentNote.placeholder' | translate"
        [validationErrors]="parentNoteValidation()"
      />
      <p class="add-duty__parent-note-meta">
        <span>{{ 'app.components.addDutyDialog.parentNote.hint' | translate }}</span>
        <span class="add-duty__parent-note-count" aria-live="polite">
          {{ parentNoteLength() }} / {{ parentNoteMaxLength }}
        </span>
      </p>
    </div>

    <div class="add-duty__rewards-block">
      <span class="parent-dialog__section-label">{{
        'app.components.addDutyDialog.rewardsLabel' | translate
      }}</span>

      @if (experiencePoolBalance(); as poolBalance) {
        <div
          class="add-duty__pool"
          [class.add-duty__pool--low]="isPoolLow()"
          [class.add-duty__pool--insufficient]="hasInsufficientXp()"
          role="status"
        >
          <img
            class="add-duty__pool-icon"
            src="/public/svgs/v-star.svg"
            alt=""
            width="16"
            height="16"
            aria-hidden="true"
          />
          <div class="add-duty__pool-copy">
            <p class="add-duty__pool-title">
              {{ 'app.components.addDutyDialog.experiencePoolLabel' | translate }}
              <span class="add-duty__pool-balance">
                {{
                  'app.components.addDutyDialog.experiencePoolLeft'
                    | translate: { count: poolBalance }
                }}
              </span>
            </p>
            <p class="add-duty__pool-hint">
              {{ 'app.components.addDutyDialog.experiencePoolHint' | translate }}
            </p>
            <p class="add-duty__pool-hint">
              {{ 'app.components.addDutyDialog.experienceRewardDefaultHint' | translate }}
            </p>
          </div>
        </div>
      }

      <div class="add-duty__rewards">
        <app-input-field
          formControlName="rewardGold"
          [suffixIcon]="'coin.svg'"
          [type]="'number'"
          [label]="'app.components.addDutyDialog.moneyReward' | translate"
          [placeholder]="'app.components.addDutyDialog.moneyRewardPlaceholder' | translate"
        />
        <app-input-field
          formControlName="rewardXp"
          [suffixIcon]="'v-star.svg'"
          [type]="'number'"
          [label]="'app.components.addDutyDialog.experienceReward' | translate"
          [placeholder]="'app.components.addDutyDialog.experienceRewardPlaceholder' | translate"
        />
      </div>

      @if (hasInsufficientXp()) {
        <p class="add-duty__xp-error" role="alert">
          {{
            'app.components.addDutyDialog.experiencePoolInsufficient'
              | translate
                : {
                    needed: totalXpCost(),
                    available: experiencePoolBalance() ?? 0,
                  }
          }}
        </p>
      }
    </div>

    @if (!isEditMode()) {
      <section class="parent-dialog__section add-duty__options">
        <span class="parent-dialog__section-label">{{ 'app.components.addDutyDialog.recurrence.label' | translate }}</span>
        <div class="add-duty__recurrence" role="radiogroup" [attr.aria-label]="'app.components.addDutyDialog.recurrence.label' | translate">
          @for (option of recurrenceOptions; track option.id) {
            <button
              type="button"
              class="add-duty__recurrence-btn"
              [class.add-duty__recurrence-btn--selected]="recurrenceFrequency() === option.id"
              [class.add-duty__option--locked]="option.id !== 'NONE' && !recurrenceAllowed()"
              [attr.aria-pressed]="recurrenceFrequency() === option.id"
              [attr.aria-disabled]="option.id !== 'NONE' && !recurrenceAllowed()"
              (click)="selectRecurrence(option.id)"
            >
              <span class="add-duty__recurrence-icon" aria-hidden="true">
                <img [src]="option.icon" alt="" width="18" height="18" />
              </span>
              <span class="add-duty__recurrence-label">{{ option.labelKey | translate }}</span>
            </button>
          }
        </div>

        <div class="add-duty__option-toggles">
        @if (showFamilyDutyOption()) {
        <button
          type="button"
          class="add-duty__family-toggle"
          [class.add-duty__family-toggle--active]="requiresParentParticipation()"
          [class.add-duty__option--locked]="!familyDutyAllowed()"
          [attr.aria-pressed]="requiresParentParticipation()"
          [attr.aria-disabled]="!familyDutyAllowed()"
          (click)="toggleFamilyDuty()"
        >
          <span class="add-duty__recurrence-icon" aria-hidden="true">
            <img src="/public/svgs/family-together.svg" alt="" width="18" height="18" />
          </span>
          <span class="add-duty__family-copy">
            <span class="add-duty__family-title">{{ 'app.components.addDutyDialog.family.title' | translate }}</span>
            <span class="add-duty__family-hint">{{ 'app.components.addDutyDialog.family.hint' | translate }}</span>
          </span>
        </button>
        }

        <button
          type="button"
          class="add-duty__family-toggle"
          [class.add-duty__family-toggle--active]="saveAsTemplate()"
          [class.add-duty__option--locked]="!routinesAllowed()"
          [attr.aria-pressed]="saveAsTemplate()"
          [attr.aria-disabled]="!routinesAllowed()"
          (click)="toggleSaveAsTemplate()"
        >
          <span class="add-duty__recurrence-icon" aria-hidden="true">
            <img src="/public/svgs/flag.svg" alt="" width="18" height="18" />
          </span>
          <span class="add-duty__family-copy">
            <span class="add-duty__family-title">{{ 'app.components.addDutyDialog.saveTemplate.title' | translate }}</span>
            <span class="add-duty__family-hint">{{ 'app.components.addDutyDialog.saveTemplate.hint' | translate }}</span>
          </span>
        </button>

        @if (saveAsTemplate() && routinesAllowed()) {
          <app-input-field
            class="add-duty__save-template-field"
            formControlName="templateName"
            [label]="'app.components.addDutyDialog.saveTemplate.nameLabel' | translate"
            [placeholder]="'app.components.addDutyDialog.saveTemplate.namePlaceholder' | translate"
            [validationErrors]="templateNameValidation()"
          />
        }
        </div>
      </section>
    }

    @if (
      isEditMode() &&
      (editRecurrenceLabelKey() ||
        (showFamilyDutyOption() && editingDuty()?.requiresParentParticipation) ||
        showStopRecurrence())
    ) {
      <section
        class="add-duty__edit-settings"
        [attr.aria-label]="'app.components.addDutyDialog.editMetaAria' | translate"
      >
        @if (
          editRecurrenceLabelKey() ||
          (showFamilyDutyOption() && editingDuty()?.requiresParentParticipation)
        ) {
          <div class="add-duty__edit-meta">
            @if (editRecurrenceLabelKey(); as recurrenceKey) {
              <span class="add-duty__meta-chip">
                <img [src]="recurrenceIcon(recurrenceFrequency())!" alt="" width="16" height="16" aria-hidden="true" />
                {{ recurrenceKey | translate }}
              </span>
            }
            @if (showFamilyDutyOption() && editingDuty()?.requiresParentParticipation) {
              <span class="add-duty__meta-chip">
                <img src="/public/svgs/family-together.svg" alt="" width="16" height="16" aria-hidden="true" />
                {{ 'app.components.addDutyDialog.family.title' | translate }}
              </span>
            }
          </div>
        }

        @if (showStopRecurrence()) {
          <label class="add-duty__stop-recurrence">
            <input type="checkbox" [checked]="stopRecurrence()" (change)="stopRecurrence.set(!stopRecurrence())" />
            <span>{{ 'app.components.addDutyDialog.stopRecurrence' | translate }}</span>
          </label>
        }
      </section>
    }
  </form>
</mat-dialog-content>

@if (showPlanNotice()) {
  <div class="add-duty__plan-notice">
    <app-info-banner
      compact
      variant="warning"
      iconUrl="/public/svgs/info.svg"
      [title]="planNoticeTitle()"
      [message]="planNoticeMessage()"
      [actionLabel]="planNoticeActionLabel()"
      [ariaLabel]="planNoticeTitle()"
      (actionClick)="onPlanNoticeAction()"
    />
    @if (showDutyBoost()) {
      <button type="button" class="add-duty__plan-link" (click)="goPlans()">
        {{ 'app.components.addDutyDialog.plan.viewPlans' | translate }}
      </button>
    }
  </div>
}

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  @if (isEditMode()) {
    <div class="parent-dialog__actions-start">
      <app-parent-button variant="icon" [disabled]="isSubmitting()" (clicked)="onCancelDuty()">
        <img src="/public/svgs/trash-red.svg" alt="" width="16" height="16" aria-hidden="true" />
      </app-parent-button>
    </div>
  }

  <div class="parent-dialog__actions-end">
    <app-parent-button variant="ghost" (clicked)="onDiscard()">
      {{ 'app.components.addDutyDialog.discard' | translate }}
    </app-parent-button>

    <app-parent-button
      variant="primary"
      [loading]="isSubmitting()"
      [disabled]="!canConfirm()"
      (clicked)="onConfirm()"
    >
      @if (!isSubmitting()) {
        <img src="/public/svgs/check-w.svg" alt="" width="14" height="14" aria-hidden="true" />
      }
      @if (isEditMode()) {
        {{ 'app.components.addDutyDialog.save' | translate }}
      } @else {
        {{ 'app.components.addDutyDialog.confirm' | translate }}
      }
    </app-parent-button>
  </div>
</mat-dialog-actions>
